<template>
  <v-form lazy-validation ref="form">
    <v-row>
      <v-col cols="12" md="6" class="pt-0">
      <span class="kbDarkBlueText--text text-subtitle-1 d-block mb-1 font-weight-medium">
        {{ $t('general.searchABusinessToAdd', { business: businessModule.s }) }}
      </span>
        <v-autocomplete color="kbDarkBlueText"
                        background-color="kbLight"
                        clearable
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="UUID"
                        :items="filteredAppBusinesses"
                        :label="$t('general.searchABusinessToAdd', { business: businessModule.s })"
                        :loading="loadingBusinesses"
                        :rules="[rules.required]"
                        :search-input.sync="localeSearch"
                        solo
                        v-model="selectedBusiness"/>
      </v-col>

      <v-col cols="12" md="6" class="py-0 pl-0">
      <span class="kbDarkBlueText--text text-subtitle-1 d-block mb-1 font-weight-medium">
        {{ $t('general.enterPersonPositionInBusiness', { business: businessModule.s } ) }}
      </span>
        <v-text-field color="kbDarkBlueText"
                      background-color="kbLight"
                      :label="$t('general.enterPersonPositionInBusiness', { business: businessModule.s })"
                      :rules="[rules.required]"
                      solo
                      v-model="personPosition" />
      </v-col>

      <v-col cols="12" class="py-0">
        <div class="d-flex justify-center">
          <v-btn :color="mainColor"
                 dark
                 :loading="loadingSubmit"
                 @click="addPersonToBusiness()">
            {{ $t('general.addPersonToBusiness', { business: businessModule.s }) }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapGetters, mapState } from 'vuex'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapGetters(['appUuid', 'companyUuid', 'businessModule']),
    ...mapState({
      businesses: state => state.businesses.businesses,
      search: state => state.businesses.search
    }),
    filteredAppBusinesses () {
      return this.businesses.filter(item => !this.userBusinesses.map(userBusiness => userBusiness.id).includes(item.id))
    },
    localeSearch: {
      get () {
        return this.search
      },
      set (value) {
        console.log('Set search value', value)
        this.$store.commit('SET_SEARCH_BUSINESSES', value)
      }
    }
  },
  created () {
    this.getAppBusinesses()
  },
  data () {
    return {
      creatingTask: false,
      loadingBusinesses: false,
      loadingSubmit: false,
      personPosition: '',
      rules,
      selectedBusiness: ''
    }
  },
  methods: {
    async addPersonToBusiness () {
      if (!this.$refs.form.validate()) return
      try {
        this.loadingSubmit = true
        await this.$store.dispatch('addContact', { businessId: this.selectedBusiness, userId: this.userId, roles: [this.personPosition] })
        this.loadingSubmit = false
        notifications.success(this.$t('general.businessSuccessfullyAdded', { business: this.businessModule.s }))
        this.getUser()
        this.toggleAddPersonToBusinessComponent()
      } catch (e) {
        this.loadingSubmit = false
        notifications.error(e)
      }
    },
    async getAppBusinesses () {
      console.log('getAppBusinesses')
      this.$store.commit('SET_PAGINATION_BUSINESSES', {
        page: 1,
        itemsPerPage: 50,
        sortBy: '',
        descending: ''
      })
      try {
        this.loadingBusinesses = true
        await this.$store.dispatch('getBusinesses')
        this.loadingBusinesses = false
      } catch (e) {
        this.loadingBusinesses = false
        notifications.error(e)
      }
    },
    getUser () {
      this.$emit('getUser')
    },
    toggleAddPersonToBusinessComponent () {
      this.$emit('toggleAddPersonToBusinessComponent')
      this.$refs.form.reset()
    }
  },
  props: {
    mainColor: {
      type: String,
      default: 'kbPink'
    },
    userId: {
      type: String,
      default: ''
    },
    userBusinesses: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    search () {
      this.getAppBusinesses()
    }
  }
}
</script>
